import fromPairs from 'lodash/fromPairs';
import sumBy from 'lodash/sumBy';

export default function getGradingActionFromTimelineAction(
  gradingReport,
  timelineAction
) {
  const { successfullyTakenActions, failedToAvoidActions } = gradingReport;

  // The action was graded by one or more grading effects
  if (timelineAction.gradingTypeIDs && timelineAction.gradingTypeIDs.length) {
    // Find the corresponding grading actions for those effects
    // and aggregate them
    const gradingActions = timelineAction.gradingTypeIDs.map((gradingTypeId) =>
      getGradingActionFromTimelineAction(gradingReport, {
        type: 'GRADING',
        typeID: gradingTypeId,
      })
    );
    return {
      points: sumBy(gradingActions, 'points'),
      isCritical: gradingActions.some(a => a.isCritical),
      isSuccess: gradingActions.some(a => a.isSuccess) && gradingActions.every(a => !a.isFailure),
      isFailure: gradingActions.some(a => a.isFailure),
    }
  }

  // IV actions are associated with several grading actions
  // In this case we return a special combined grading action
  if (timelineAction.type === 'IV_ACTION') {
    const extraInfos = fromPairs(timelineAction.extraInfos.map(extraInfo => [extraInfo.key, extraInfo.value]));
    const successfulGradingActions = successfullyTakenActions.filter(a => a.type.startsWith('IV_')).filter(a => extraInfos[a.type] === a.typeID);
    const failedGradingActions = failedToAvoidActions.filter(a => a.type.startsWith('IV_')).filter(a => extraInfos[a.type] === a.typeID);
    const allGradingActions = [...successfulGradingActions, ...failedGradingActions];
    return {
      points: null,
      isCritical: allGradingActions.some(a => a.isCritical),
      isSuccess: !!successfulGradingActions.length && !failedGradingActions.length,
      isFailure: !!failedGradingActions.length,
    }
  }

  const findGradingAction = (actionList) =>
    actionList.find((gradingAction) => {
      const extraInfos = fromPairs((timelineAction.extraInfos || []).map(extraInfo => [extraInfo.key, extraInfo.value]));
      if (
        timelineAction.type === 'MEDICATION' &&
        gradingAction.type === 'MEDICATION_ROUTE'
      ) {
        return (
          timelineAction.label === gradingAction.label &&
          extraInfos.MEDICATION_ROUTE === gradingAction.typeID
        );
      }
      if (
        timelineAction.type === 'OXYGEN' &&
        gradingAction.type === 'OXYGEN_TYPE'
      ) {
        return timelineAction.typeID === gradingAction.typeID;
      }
      return (
        timelineAction.type === gradingAction.type &&
        timelineAction.typeID === gradingAction.typeID
      );
    });

  const successfulGradingAction = findGradingAction(successfullyTakenActions);
  const failedGradingAction = findGradingAction(failedToAvoidActions);
  const gradingAction = successfulGradingAction || failedGradingAction;
  if (!gradingAction) {
    return null;
  }
  return {
    ...gradingAction,
    isSuccess: !!successfulGradingAction,
    isFailure: !!failedGradingAction,
  };
}
